"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var ProductCommunity = function ProductCommunity(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Product Area",
    focusable: "false"
  }, props), (0, _preact.h)("rect", {
    x: "0.5",
    y: "0.5",
    width: "47",
    height: "47",
    rx: "7.5",
    stroke: "#E6E9EC"
  }), (0, _preact.h)("g", {
    "clip-path": "url(#clip0_2637_113138)"
  }, (0, _preact.h)("path", {
    d: "M17.6982 16.6094C18.875 16.6094 19.9492 16.8114 20.9209 17.2148C21.8922 17.6187 22.7133 18.2173 23.3838 19.0107L21.6602 20.6328C21.1263 20.0718 20.5377 19.6508 19.8945 19.3701C19.2512 19.0897 18.5601 18.9492 17.8213 18.9492C17.0683 18.9492 16.3804 19.073 15.7578 19.3193C15.1351 19.5656 14.5951 19.9145 14.1367 20.3662C13.6781 20.8177 13.3185 21.3509 13.0586 21.9668C12.7985 22.5825 12.669 23.2602 12.6689 23.999C12.6689 24.738 12.7985 25.4157 13.0586 26.0312C13.3185 26.647 13.678 27.1813 14.1367 27.6328C14.5951 28.0844 15.1351 28.4334 15.7578 28.6797C16.3804 28.926 17.0683 29.0488 17.8213 29.0488C18.5601 29.0488 19.2512 28.9096 19.8945 28.6289C20.5377 28.3485 21.1263 27.9204 21.6602 27.3457L23.3838 28.9668C22.7133 29.7607 21.8924 30.3627 20.9209 30.7734C19.9492 31.1838 18.8683 31.3896 17.6777 31.3896C16.5694 31.3896 15.5495 31.2078 14.6191 30.8457C13.6885 30.4831 12.8774 29.9664 12.1865 29.2959C11.4954 28.6255 10.9573 27.8448 10.5742 26.9551C10.1911 26.0657 10 25.0802 10 23.999C10 22.9183 10.191 21.9326 10.5742 21.043C10.9572 20.1536 11.4985 19.3739 12.1963 18.7031C12.8943 18.0327 13.7089 17.5161 14.6396 17.1533C15.5701 16.7909 16.5898 16.6094 17.6982 16.6094ZM32.3135 16.6094C33.4902 16.6094 34.5653 16.8113 35.5371 17.2148C36.5083 17.6187 37.3295 18.2173 38 19.0107L36.2754 20.6328C35.7416 20.0718 35.1529 19.6508 34.5098 19.3701C33.8667 19.0899 33.176 18.9493 32.4375 18.9492C31.6846 18.9492 30.9968 19.073 30.374 19.3193C29.7512 19.5656 29.2103 19.9144 28.752 20.3662C28.2934 20.8176 27.9346 21.3511 27.6748 21.9668C27.4147 22.5825 27.2842 23.2602 27.2842 23.999C27.2842 24.7381 27.4147 25.4156 27.6748 26.0312C27.9346 26.6469 28.2933 27.1813 28.752 27.6328C29.2103 28.0846 29.7512 28.4334 30.374 28.6797C30.9967 28.9259 31.6846 29.0488 32.4375 29.0488C33.176 29.0488 33.8667 28.9094 34.5098 28.6289C35.1528 28.3485 35.7416 27.9202 36.2754 27.3457L38 28.9668C37.3295 29.7607 36.5084 30.3627 35.5371 30.7734C34.5653 31.1838 33.4836 31.3896 32.293 31.3896C31.1846 31.3896 30.1647 31.2079 29.2344 30.8457C28.3037 30.4831 27.4925 29.9665 26.8018 29.2959C26.1106 28.6255 25.5735 27.8448 25.1904 26.9551C24.8073 26.0657 24.6162 25.0802 24.6162 23.999C24.6162 22.9183 24.8073 21.9326 25.1904 21.043C25.5735 20.1536 26.1148 19.3739 26.8125 18.7031C27.5105 18.0328 28.3243 17.516 29.2549 17.1533C30.1853 16.7909 31.2051 16.6094 32.3135 16.6094Z",
    fill: "#EF508B"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_2637_113138"
  }, (0, _preact.h)("rect", {
    width: "28",
    height: "14.7804",
    fill: "white",
    transform: "translate(10 16.6094)"
  }))));
};

var _default = ProductCommunity;
exports.default = _default;